import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import BookingStatusPill from 'features/BookingDetails/BookingStatusPill'
import GuestDetails from 'features/BookingDetails/GuestDetails'
import Reservation from 'features/BookingDetails/Reservation'
import EditBookingDialog from 'features/EditBookingDialog'
import BookingPaymentInfoDialog from 'features/GDSBookings/BookingPaymentInfoDialog'
import { useEffect } from 'react'
import { useState } from 'react'
import bookingsApi from 'services/api/bookings'

import styles from './BookingDetailsDialog.module.scss'

const BookingDetailsDialog = ({ onClose, onBack, bookingId }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState(false)
  const [booking, setBooking] = useState(null)

  const [index, setIndex] = useState(0)

  const [isPaymentInfoDialogVisible, setIsPaymentInfoDialogVisible] = useState(false)

  useEffect(() => {
    setIsLoading(true)
    setIsErred(false)

    bookingsApi
      .one({ bookingId })
      .then(booking => {
        setBooking(booking)
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [bookingId, index])

  const [isEditBookingDialogVisible, setIsEditBookingDialogVisible] = useState()

  if (isEditBookingDialogVisible) {
    return (
      <EditBookingDialog
        booking={booking}
        bookingId={bookingId}
        onClose={onClose}
        onBack={() => setIsEditBookingDialogVisible(false)}
        onSave={() => setIndex(index + 1)}
      />
    )
  }

  if (isPaymentInfoDialogVisible) {
    return (
      <BookingPaymentInfoDialog
        paymentAccountId={booking.accountPaymentAccountId}
        onClose={() => setIsPaymentInfoDialogVisible(false)}
      />
    )
  }

  if (isLoading) {
    return (
      <Dialog>
        <LoadingIndicator white />
      </Dialog>
    )
  }

  return (
    <ConfirmationDialog
      onClose={onClose}
      onBack={onBack}
      hasConfirmButton={false}
      theme="blacklist"
      title="Reservation details"
      maxWidth={1000}
    >
      <div className={styles.dialogInner}>
        {isLoading && <LoadingIndicator />}
        {isErred && <p>Something went wrong while loading the booking</p>}
        {!isLoading && !isErred && booking && (
          <div className={styles.dialogInner}>
            <div className={styles.reservationHolder}>
              <h2 className={styles.reservationTitle}>
                Reservation{' '}
                <BookingStatusPill
                  status={booking.status}
                  bookingDate={booking.bookingDate}
                />
              </h2>
              <Reservation {...booking} />
            </div>
            <div>
              <GuestDetails
                {...booking}
                fullName={`${booking.guestFirstName} ${booking.guestLastName}`}
                phone={booking.phoneNumber}
                onClose={onClose}
              />
              {booking.status === 'Pending' && (
                <div style={{ paddingTop: 14, display: 'flex' }}>
                  <PrimaryRegularButton
                    onClick={() => setIsEditBookingDialogVisible(true)}
                  >
                    Edit booking
                  </PrimaryRegularButton>
                  <SecondaryRegularButton
                    style={{ background: 'white', marginLeft: 4 }}
                    onClick={() => setIsPaymentInfoDialogVisible(true)}
                  >
                    See payment details
                  </SecondaryRegularButton>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default BookingDetailsDialog
